import apiClient from "../../client/apiClient"

export type ParentStudent = {
  id: string
  gr_number: string
  full_name: string
  fathers_name?: string
}

export type ParentReportCard = {
  id: string
  enrollmentId: string
  breakdownId: string
  breakdown_title: string
  session_name: string
  class_name: string
}

export const getParentStudents = async (): Promise<{
  success: boolean
  data: { items: ParentStudent[] }
}> => {
  const res = await apiClient({ method: "GET", url: "/parent/me/students" })
  return res.data
}

export const getStudentReportCards = async (studentId: string): Promise<{
  success: boolean
  data: { items: ParentReportCard[] }
}> => {
  const res = await apiClient({ method: "GET", url: `/parent/me/students/${studentId}/report-cards` })
  return res.data
}

export const getReportCardPdfUrl = async (
  enrollmentId: string,
  breakdownId: string
): Promise<{ success: boolean; data: { url: string } }> => {
  const res = await apiClient({
    method: "GET",
    url: `/parent/me/report-cards/${enrollmentId}/${breakdownId}/pdf`,
  })
  return res.data
}
